<div class="loading-indicator-wrapper" *ngIf="route_spinner || processes.length > 0">
    <span class="k-i-loading k-icon loading-indicator-spinner"></span>
</div>